import { Button } from "components/Button/Button";
import { motion } from "framer-motion";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "routes";

import { AvatarEditorProvider } from "./avatar-editor-provider";
import { AppIcon } from "assets/app/app-icon";
import { AsyncProcess } from "services/AsyncProcess";
import { ReplaceWords } from "utils/ReplaceWords";
import { useSelector } from "react-redux";
import { RootStateType } from "storeRedux/store";
import { useLangContext } from "context/Lang";
import { AvatarEditorEnvironment } from "./avatar-editor-environment/avatar-editor-environment";




type AvatarEditorProps = {
    // buildingId?: number;
    mapId?:number;
    editorId?:number;
    canEdit?: boolean;
    onDataLoad?: (e?: any) => void;
    inDialog?:boolean;

}



export const AvatarEditor = ({ canEdit = true,inDialog=false,mapId, ...props }: AvatarEditorProps): ReactElement => {


    const [canEditServer,setCanEditServer] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const mapEditorId = props?.editorId || searchParams.get("editorId");


    // useEffect(()=>{
    //     canEdit&&AsyncProcess({
    //         type:"post",
    //         url:ReplaceWords(routes.api.threeItemEditorCheckEdit,{id:mapEditorId}),
            
    //         setError:()=>{

    //         },

    //         effectProcess:[(res)=>{
    //             if(res?.success!==false){
    //                 setCanEditServer(res?.data)
    //             }
    //         }]
    //     })
    // },[]);  

    return <AvatarEditorProvider editorId={props.editorId}   onDataLoad={props?.onDataLoad}>
        <AvatarEditorContent  {...{ canEdit:canEditServer,inDialog }} />
    </AvatarEditorProvider>
}



const AvatarEditorContent = ({ canEdit, inDialog }: AvatarEditorProps) => {
    const navigate = useNavigate();
    const { gW } = useLangContext(); 
    
    // جلب بيانات المستخدم الحالية من Redux Store
    const { user } = useSelector((state: RootStateType) => state.auth);

    return (
        <>
            <div className="w-full h-full select-none overflow-hidden rounded-xl  text-white relative">
                
                <div className="relative backdrop-blur-lg  bg-primary-900/80 z-[100] top-0 left-0 p-2 px-4 w-full flex h-[70px] border-b border-primary/10 items-center justify-between" >
                    
                    <motion.div 
                        initial={{ x: -50, opacity: 0 }} 
                        animate={{ x: 0, opacity: 1 }} 
                        transition={{ duration: 0.4, type: "spring" }} 
                        className="h-full flex items-center gap-2"
                    >
                        <div className="flex flex-col">
                            <span className="text-sm font-bold tracking-wide text-primary-100">
                                {gW("avatar-editor") }
                            </span>
                            <span className="text-[11px] text-primary-200">
                                {gW("avatar-campus-title") }
                            </span>
                        </div>
                    </motion.div>

                    {user && (
                        <motion.div 
                            initial={{ x: 50, opacity: 0 }} 
                            animate={{ x: 0, opacity: 1 }} 
                            transition={{ duration: 0.4, type: "spring" }}
                            className="flex items-center gap-3 bg-white/5 border border-white/10 p-1.5 px-3 rounded-xl"
                        >
                            <div className="flex   flex-col text-right">
                                <span className="text-xs font-semibold text-white">
                                    {user?.name} {user?.surname}
                                </span>
                                <span className="text-[10px] text-primary-200">
                                    {user?.userName }
                                </span>
                            </div>
                            
                            <div className="w-8 h-8 rounded-lg  border border-primary-600 flex items-center justify-center text-primary text-sm font-bold ">
                                {user?.name ? user.name.charAt(0).toUpperCase() : "U"}
                            </div>
                        </motion.div>
                    )}
                </div>
            

                <div className="absolute z-10  top-0   w-full h-full">
                    <AvatarEditorEnvironment  canEdit={true} />
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="absolute bottom-6  left-6 z-10 max-w-[320px] bg-primary-900/80 backdrop-blur-md border border-primary p-4 rounded-xl shadow-2xl"
                >
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                        <h4 className="text-xs font-bold uppercase tracking-wider text-primary-100">
                            {gW("avatar-preview-mode") }
                        </h4>
                    </div>
                    <p className="text-xs text-primary-200 leading-relaxed">
                        {gW("avatar-editor-desc") }
                    </p>
                </motion.div>

               

            </div>
        </>
    );
};